// extracted by css-extract-rspack-plugin
export default {"root":"DashboardNotificationCard-module__root___DetrO","message":"DashboardNotificationCard-module__message___NfrYf","icon":"DashboardNotificationCard-module__icon___FRmuM"};